import { translate } from "app/filters/i18nFilter";
import type { ExportItem } from "app/pages/sales-intelligence/sub-modules/management/store/type";

import {
    ADD_FIELD,
    PRE_DEFINED_CREATE_FIELD,
    PRE_DEFINED_FIELD,
    PRE_DEFINED_UPDATE_FIELD,
    TECHNOGRAPHICS_FIELD,
} from "./const";
import type { SimilarwebFieldConfig } from "./types";
import { similarwebValueType } from "./valueType";

export const INTERNAL_ADD_ITEM_TEXT = "internal_addItem";
export const PREDEFINED_ITEM_USER_TEXT = "Predefined field";
export const PREDEFINED_CREATE_ITEM_USER_TEXT = "Predefined on Create";
export const PREDEFINED_UPDATE_ITEM_USER_TEXT = "Predefined on Update";
export const TECHNOGRAPHICS_ITEM_USER_TEXT = "Technographics";

export const PREDEFINED_FIELD_TOOLTIP_KEY = "si.management.integration.export.pre_defined.field.tooltip";
export const PREDEFINED_CREATE_FIELD_TOOLTIP_KEY = "si.management.integration.export.pre_defined_create.field.tooltip";
export const PREDEFINED_UPDATE_FIELD_TOOLTIP_KEY = "si.management.integration.export.pre_defined_update.field.tooltip";

export const addItem: ExportItem = {
    field: ADD_FIELD,
    get title() {
        return translate("si.management.integration.export.add.field.dropdown");
    },
    externalField: INTERNAL_ADD_ITEM_TEXT,
    example: "internal_add_example",
    overwrite: false,
    delete: null,
};

export const addPreDefinedItem: SimilarwebFieldConfig = {
    example: "",
    field: PRE_DEFINED_FIELD,
    valueType: similarwebValueType.Text,
    tooltipKey: PREDEFINED_FIELD_TOOLTIP_KEY,
    get name() {
        return translate("si.management.integration.export.pre_defined.field.dropdown");
    },
};

export const addPreDefinedCreateItem: SimilarwebFieldConfig = {
    example: "",
    field: PRE_DEFINED_CREATE_FIELD,
    valueType: similarwebValueType.Text,
    tooltipKey: PREDEFINED_CREATE_FIELD_TOOLTIP_KEY,
    get name() {
        return translate("si.management.integration.export.pre_defined_create.field.dropdown");
    },
};

export const addPreDefinedUpdateItem: SimilarwebFieldConfig = {
    example: "",
    field: PRE_DEFINED_UPDATE_FIELD,
    valueType: similarwebValueType.Text,
    tooltipKey: PREDEFINED_UPDATE_FIELD_TOOLTIP_KEY,
    get name() {
        return translate("si.management.integration.export.pre_defined_update.field.dropdown");
    },
};

export const addTechographicsItem: SimilarwebFieldConfig = {
    example: "",
    field: TECHNOGRAPHICS_FIELD,
    valueType: similarwebValueType.List,
    get name() {
        return translate("grow.lead_generator.exist.table.column.technographics");
    },
};

export enum DataTypeMap {
    Picklist = "text",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Boolean = "text",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Text = "text",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Date = "text",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    DateTime = "text",
    Numeric = "number",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Reference = "text",
}

export enum ExportTabs {
    account = 0,
    contact,
    lead,
}
